import CartSdkReadySdkEvent from "@modules/sdk/common_sdk/events/CartSdkReadySdkEvent";
import { dispatchSdkEvent } from "@modules/sdk/helpers";
import Sdk from "@modules/sdk/Sdk";
import { SdkRegisteredModuleInterface } from "@modules/sdk/SdkRegisteredModuleInterface";

import { DiscountService } from "../service/DiscountService";
import { DiscountSdkMethods } from "./DiscountSdkMethods";

export class DiscountSdk implements SdkRegisteredModuleInterface {
    public readonly methods: DiscountSdkMethods;

    constructor(discountService: DiscountService) {
        this.methods = new DiscountSdkMethods(discountService);
    }

    public register(sdk: Sdk & { discounts?: DiscountSdk }) {
        sdk.discounts = this;

        dispatchSdkEvent(new CartSdkReadySdkEvent());
    }
}
